import React from 'react'
import { Route, Switch } from 'react-router-dom/cjs/react-router-dom'
import Cancui from './Cancui'
import CancuiDetails from './CancuiDetails'
import './Cancui.css'

const CancuiContainer = ({ match }) => {
    return (
        <Switch>
            <Route exact path={`${match.path}`} component={Cancui} />
            <Route exact path={`${match.path}/:id`} component={CancuiDetails} />
        </Switch>
    )
}

export default CancuiContainer